export const SENTRY_RELEASE: string | undefined = '4e35252a460acc46039a3fbcd0499f9062418a28';
